<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <div>
                        <img src="@/assets/images/charging-cancel.png" alt="" />
                    </div>
                    <span>{{alertMessage}}</span>
                </div>
            </div>
          <div class="button-wrap">
            <button class="button-bg-yellow border-round" @click="modalClose()">확인</button>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginAlertPopup',
    data() {
        return  {
          alertMessage: '로그인이 필요한 서비스 입니다.'
        }
    },
    created() {
      if(window.location.pathname == '/award/emarticonAwardHome') {
        this.alertMessage = '점포코드 입력이 필요합니다';
      }
    },
    methods : {
      /**
       * 로그인 경고 모달 close
       */
      modalClose(){
        this.$emit('loginModalUpdate', [false]);
        // window.location.href = process.env.VUE_APP_EMART_SITE_WEB + "/login/login.do?retUrl=/api/v1/member/membership/ematicon";
        if(window.location.pathname == '/award/emarticonAwardHome') {
          if(this.$route.path !== '/award/awardCode') this.$router.push({path: "/award/awardCode"});
          document.body.style.overflow = ''; //스크롤 활성
        } else {
          window.location.href = process.env.VUE_APP_EMART_SITE_WEB + "/api/v1/member/membership/ematicon/gate?url=" + this.$store.state.loginPath;
        }
      }
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/cards/loginAlertPopup.scss';
  @import '@/assets/styles/common/bottomButton.scss';
</style>